import { useRecoilState } from "recoil"
import { loading } from "../atom"

const useLoadingState = () => {
    return useRecoilState(loading);
};

export default useLoadingState;